exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#chart[data-v-82f41484] {\n  max-width: 100%;\n}\n", ""]);

// exports
